if (!customElements.get("filter-based-results")) {
    class FilterBasedResults extends HTMLElement {
        constructor() {
            super();

            this.validUrl = null;
            this.form = this.querySelector("form");
            this.departmentsList = this.form.querySelector("#DepartmentsList");
            this.optionsSelect = this.form.querySelector("#options-list");
            this.metafieldsSelect = this.form.querySelector("#metafields-list");
            this.multiMetafieldsSelect = this.form.querySelector(
                "#multi-metafields-list"
            );
            this.data = this.fetchFiltersJsonData();

            this.bindEvents();
        }

        fetchFiltersJsonData() {
            if (window.AutoGearVehicleFinderData) {
                return window.AutoGearVehicleFinderData;
            }

            const json = document.getElementById("department-filters-data");
            return JSON.parse(json?.textContent || "{}");
        }

        bindEvents() {
            this.departmentsList.addEventListener("click", (e) => {
                e.preventDefault();
                const department = e.target.dataset.value;

                if (!department || !this.data[department]) return;

                this.resetOptions();
                this.updateSummaryValue(e);
                this.form.dataset.department = department;
                this.renderOptions(department);
                this.renderMetafieldsOptions(department);
            });

            this.optionsSelect &&
                this.optionsSelect.addEventListener("click", (e) => {
                    this.toggleAction(e);
                });

            this.metafieldsSelect &&
                this.metafieldsSelect.addEventListener("click", (e) => {
                    this.updateSummaryValue(e);
                    this.resetDependentMetafield();
                    this.renderLinkedMetafieldsOptions(e.target.dataset.value);
                    this.updateActionState();
                });

            this.multiMetafieldsSelect &&
                this.multiMetafieldsSelect.addEventListener("click", (e) => {
                    this.toggleAction(e);
                });

            this.form.addEventListener("submit", this.handleSubmit.bind(this));
        }

        toggleAction(e) {
            this.updateSummaryValue(e);
            this.updateActionState();
        }

        handleSubmit(e) {
            e.preventDefault();
            if (this.validUrl) window.location.href = this.validUrl;
        }

        async updateActionState() {
            const action = this.form.querySelector('button[type="submit"]');
            action.textContent = action.dataset.label;
            action.setAttribute("disabled", true);

            if (this.isValidSelection() > 0) {
                this.validUrl = null;
                return;
            }

            const url = await this.getActionUrl();
            if (url == null) {
                this.validUrl = null;
                return;
            }

            this.validUrl = url;
            action.removeAttribute("disabled");
        }

        async getActionUrl() {
            const department = this.form?.dataset?.department;
            if (!department) return null;

            const baseUrl = `/collections/${department}`;

            const getActive = (container) =>
                container?.querySelector("li.active")?.dataset;

            const option = getActive(this.optionsSelect);
            const metafield = getActive(this.metafieldsSelect);
            const multiMetafield = getActive(this.multiMetafieldsSelect);

            const params = new URLSearchParams();

            if (option?.value) {
                const normalizedName = option.option
                    .toLowerCase()
                    .replace(/\s+/g, "-");
                params.append(
                    `filter.v.option.${normalizedName}`,
                    option.value
                );
            }

            if (metafield?.value) {
                const name = this.metafieldsSelect?.dataset?.metafieldsName;
                if (name) {
                    params.append(`filter.p.m.${name}`, metafield.value);
                }
            }

            if (multiMetafield?.value) {
                const name =
                    this.multiMetafieldsSelect?.dataset?.metafieldsName;
                if (name) {
                    params.append(`filter.p.m.${name}`, multiMetafield.value);
                }
            }

            if (!params.toString()) return baseUrl;

            params.append("sort_by", "title-ascending");

            const url = `${baseUrl}?${params.toString()}`;
            const hasResults = await this.hasResults(url);

            return hasResults ? url : null;
        }

        async hasResults(url) {
            const config = {
                headers: {
                    "X-Requested-With": "XMLHttpRequest",
                },
            };

            try {
                const response = await fetch(url, config);

                if (!response.ok) return false;

                const html = await response.text();
                const parser = new DOMParser();
                const content = parser.parseFromString(html, "text/html");
                const products = content.querySelectorAll(
                    "#main-collection-products > .grid-item"
                );
                const action = this.form.querySelector('button[type="submit"]');
                action.textContent = `Found ${products.length} item(s)`;
                return products.length > 0;
            } catch (e) {
                console.error("Fetch failed:", e);
                return false;
            }
        }

        isValidSelection() {
            return this.form.querySelectorAll(
                'summary[data-valid-value="false"]'
            ).length;
        }

        resetOptions() {
            if (this.optionsSelect) this.optionsSelect.innerHTML = "";
            if (this.metafieldsSelect) this.metafieldsSelect.innerHTML = "";
            if (this.multiMetafieldsSelect)
                this.multiMetafieldsSelect.innerHTML = "";

            this.form.querySelectorAll("summary").forEach((summary) => {
                summary.dataset.validValue = false;
                summary.firstElementChild.innerHTML =
                    summary?.dataset?.value || "";
            });

            [
                this.optionsSelect,
                this.metafieldsSelect,
                this.multiMetafieldsSelect,
            ].forEach((container) => {
                container?.closest("details")?.classList.add("disabled");
            });
        }

        resetDependentMetafield() {
            if (!this.multiMetafieldsSelect) return;

            this.multiMetafieldsSelect.innerHTML = "";
            const details = this.multiMetafieldsSelect.closest("details");
            const summary = details?.querySelector("summary");

            details?.classList.add("disabled");
            if (summary) {
                summary.dataset.validValue = false;
                summary.firstElementChild.innerHTML =
                    summary?.dataset?.value || "";
            }
        }

        renderOptions(departmentHandle) {
            const departmentData = this.data[departmentHandle];
            if (!departmentData || !departmentData.options) return;

            departmentData.options.forEach((opt) => {
                const option = document.createElement("li");
                option.classList.add("option-item");
                option.setAttribute("role", "button");
                option.dataset.option = opt.name;
                option.dataset.value = opt.handle;
                option.textContent = `${opt.name} - ${opt.value}`;
                this.optionsSelect.appendChild(option);
            });

            this.optionsSelect &&
                this.optionsSelect
                    .closest("details")
                    .classList.remove("disabled");
        }

        renderMetafieldsOptions(departmentHandle) {
            const departmentData = this.data[departmentHandle];
            if (!departmentData) return;

            this.renderList(departmentData.metafields, this.metafieldsSelect);

            if (!departmentData.linked_metafields?.length) {
                this.renderList(
                    departmentData.multi_metafields,
                    this.multiMetafieldsSelect
                );
            }
        }

        renderLinkedMetafieldsOptions(primaryValue) {
            const department = this.form?.dataset?.department;
            const departmentData = this.data[department];
            if (!departmentData || !this.multiMetafieldsSelect) return;

            const linked = departmentData.linked_metafields || [];
            const values = linked
                .filter((item) => item.primary === primaryValue)
                .map((item) => item.secondary);

            this.renderList([...new Set(values)], this.multiMetafieldsSelect);
        }

        renderList(list, container) {
            if (!list || !container) return;

            container.innerHTML = "";

            list.forEach((opt) => {
                if (opt == null) return;

                const value =
                    typeof opt === "object" && opt.value ? opt.value : opt;
                const label =
                    typeof opt === "object" && opt.label ? opt.label : value;

                const li = document.createElement("li");
                li.className = "option-item";
                li.setAttribute("role", "button");
                li.dataset.value = li.dataset.option = value;
                li.textContent = label;

                container.appendChild(li);
            });

            if (container.children.length > 0) {
                container.closest("details")?.classList.remove("disabled");
            }
        }

        removeActiveClass(e) {
            const list = e.target.closest("ul");
            const activeList = list.querySelectorAll("li.active");
            activeList.forEach((opt) => opt.classList.remove("active"));
        }

        closeDetails() {
            const details = this.form.querySelectorAll("details");
            if (!details) return;
            details.forEach((detail) => detail.removeAttribute("open"));
        }

        updateSummaryValue(e) {
            this.removeActiveClass(e);
            this.closeDetails();

            const details = e.target.closest("details");
            const summary = details.querySelector("summary");
            summary.dataset.validValue = true;
            summary.firstElementChild.innerHTML = e.target.textContent;
            e.target.classList.add("active");
        }
    }

    customElements.define("filter-based-results", FilterBasedResults);
}
